import {
  Card,
  CardContent,
  Button,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import adminService from "../../Services/adminService";
import { getFullName } from "../../Services/utils";

export default function TrackingEmployees() {
  const [salesAccList, setSalesAccList] = useState([]);
  const [dataToBeShown, setDataToBeShown] = useState([]);
  const [allTrackingData, setAllTrackingData] = useState([]);
  const [saleAccSelected, setSaleAccSelected] = useState("");
  const [selectedCardNum, setSelectedCardNum] = useState("all");
  const [startDate, setStartDate] = useState(moment().add(-1, "days").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().add(1, "days").format("YYYY-MM-DD"));
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    adminService.getSalesAccountsList().then((res) => {
      if (res["success"]) {
        setSalesAccList(res.salesAccs);
      }
    });
  }, []);

  return (
    <div className="mt-50 mb-50">
      <Card>
        <CardContent>
          <FormControl className="ml-20 mr-20">
            <InputLabel className="align-select-label">בחר עובד</InputLabel>
            <Select className="select-field" value={saleAccSelected} onChange={(e) => setDataBySalesman(e.target.value)} displayEmpty>
              {salesAccList.map((acc) => {
                return (
                  <MenuItem key={acc.email} value={acc.email}>
                    {getFullName(acc.firstName, acc.lastName)}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <div className="mt-20">
            <div className="inline-block">
              <div>תחילת חיפוש</div>
              <input
                onChange={(e) => setStartDate(e.target.value)}
                className="date-field padding13"
                type="date"
                value={startDate}
                min={moment().add(-30, "days").format("YYYY-MM-DD")}
                max={moment().format("YYYY-MM-DD")}
              />
            </div>

            <div className="mr-20 inline-block">
              <div>סוף חיפוש</div>
              <input
                onChange={(e) => setEndDate(e.target.value)}
                className="date-field padding13"
                type="date"
                value={endDate}
                max={moment().add(30, "days").format("YYYY-MM-DD")}
                min={moment(startDate).format("YYYY-MM-DD")}
              />
            </div>
          </div>

          <div className="mt-20">
            <Button onClick={getSalesAccActivity} color="primary" variant="contained">
              הצג
            </Button>
          </div>
        </CardContent>
      </Card>
      <div className="mt-20">
        {dataToBeShown.map((item, i) => {
          return (
            <Accordion
              expanded={expanded === i}
              onChange={() => setExpanded(expanded === i ? null : i)}
              style={{ marginTop: "5px" }}
              key={item.id}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                <Typography>
                  <b>{`${i === 0 ? "התחברות האחרונה" : "התחברות"}`}: -</b>
                </Typography>
                <Typography style={{ flexGrow: 1 }}>
                  <b>{moment(item.loginSessions.dateCreated).format("בתאריך DD/MM בשעה HH:mm")}</b>
                </Typography>
                <Typography style={{ marginLeft: "15px" }}>
                  <b>
                    {item.loginSessions.loggedOut
                      ? moment(item.loginSessions.loggedOut).format(
                          `התנתק ${item.loginSessions.automaticLogout ? "אוטומטי" : "ידני"}:  DD/MM בשעה HH:mm `
                        )
                      : "עדיין מחובר"}
                  </b>
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <div className="flex flex-around width100" style={{ alignItems: "baseline" }}>
                  <div style={{ borderLeft: "1px solid blue", paddingLeft: "20px", height: "80%" }}>
                    <b className="primary-color">כרטיסים שנכנסו אליהם: {item.loginSessions.ticketsAccessed?.length} </b>
                    <div
                      className={`pointer ${selectedCardNum === "all" ? "yellow-color" : "primary-color"}`}
                      onClick={() => handleTicketClicked(i, "all")}
                    >
                      <b>הצג הכל</b>
                      {<ArrowLeftIcon />}
                    </div>
                    {item.loginSessions.ticketsAccessed?.map((ticket, ticketInd) => {
                      return (
                        <div
                          className={`pointer ${selectedCardNum === ticketInd + i ? "yellow-color" : "primary-color"}`}
                          onClick={() => handleTicketClicked(i, ticket.ticket, ticketInd)}
                          key={ticketInd}
                        >
                          <b>
                            {ticket.ticket} - {ticket.times?.length} פעמים
                          </b>
                          {selectedCardNum === ticketInd + i && <ArrowLeftIcon />}
                        </div>
                      );
                    })}
                  </div>
                  <div className="mt-20">
                    <b>סך הכל: {item.totalCounter.membershipsChanges}</b>
                    <div style={{ border: "2px solid blue", padding: "15px", borderRadius: "15px" }}>
                      <b className="primary-color">שינויים למנויים: {item.loginSessions.membershipsChanges?.length}</b>
                      {item.loginSessions?.membershipsChanges?.map((membership, membInd) => {
                        return (
                          <div key={membInd}>
                            <b className={getActionColor(membership.action)}>{membership.action}</b>-{" "}
                            {moment(membership.time).format("בשעה HH:mm")}
                            {membership.changes &&
                              Object.keys(membership.changes).map((field, i) => {
                                const change = membership.changes[field];
                                const hasNewValue = hasTrackingNewValue(change);
                                return (
                                  <div key={i}>
                                    {hasNewValue ? (
                                      field === "endOfSubscription" ? (
                                        <div>
                                          <b>{field}</b> <span className="active-color ">old: </span>
                                          {moment(change.old).format("DD/MM/YYYY")},{"  "}
                                          <span className="success-color">new: </span>
                                          {moment(change.new).format("DD/MM/YYYY")}
                                        </div>
                                      ) : (
                                        <div>
                                          <b>{field}</b> <span className="active-color ">old: </span> {formatTrackingValue(change.old)},
                                          {"  "}
                                          <span className="success-color">new: </span>
                                          {formatTrackingValue(change.new)}
                                        </div>
                                      )
                                    ) : (
                                      <div>
                                        <b>{field}:</b> {formatTrackingValue(change)}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            <hr />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="mt-20">
                    <b>סך הכל: {item.totalCounter.assignments}</b>
                    <div style={{ border: "2px solid blue", padding: "15px", borderRadius: "15px" }}>
                      <b className="primary-color">משימות: {item.assignments?.length}</b>
                      {item.assignments?.map((assignment, assingmentInd) => {
                        return (
                          <div key={assingmentInd}>
                            <div>
                              <b>מנויים: </b>
                              {assignment.assignmentTags}
                            </div>
                            <div>
                              <b>הערה: </b>
                              {assignment.assignmentTxt}
                            </div>
                            <div>
                              <b>תאריך יעד: </b>
                              {moment(assignment.dueDate).format("DD/MM/YYYY")}
                            </div>
                            <div>
                              <b>שם משרד: </b>
                              {assignment.officeName}
                            </div>
                            <hr />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="mt-20">
                    <b>סך הכל: {item.totalCounter.comments}</b>
                    <div style={{ border: "2px solid blue", padding: "15px", borderRadius: "15px" }}>
                      <b className="primary-color">התקשרויות: {item.comments[0]?.comments.length}</b>
                      {item.comments?.map((comments, commentsInd) => {
                        return (
                          <div key={commentsInd}>
                            <div>
                              {comments.comments.map((comment, commentInd) => {
                                return (
                                  <>
                                    <div>
                                      <b>מנויים: </b>
                                      {comment.commentTags}
                                    </div>
                                    <div>
                                      <b>הערה: </b>
                                      {comment.commentTxt}
                                    </div>
                                    <div>{moment(comment.dateCreated).format("בשעה HH:mm")}</div>
                                    <hr />
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="mt-20">
                    <b>סך הכל: {item.totalCounter.sales}</b>
                    <div style={{ border: "2px solid blue", padding: "15px", borderRadius: "15px" }}>
                      <b className="primary-color">מכירות: {item.sales[0]?.sales.length}</b>
                      {item.sales?.map((sales, salesInd) => {
                        return (
                          <div key={salesInd}>
                            <div>
                              {sales.sales?.map((sale, saleInd) => {
                                return (
                                  <>
                                    <div>
                                      <b>מנויים: </b>
                                      {sale.commentTags}
                                    </div>
                                    <div>
                                      <b>מוצר: </b>
                                      {sale.productType}
                                    </div>
                                    <div>
                                      <b>מחיר: </b>
                                      {sale.price}₪
                                    </div>
                                    <div>
                                      <b>הערה: </b>
                                      {sale.productFreeTxt}
                                    </div>
                                    <div>{moment(sale.dateCreated).format("בשעה HH:mm")}</div>
                                    <hr />
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </div>
  );

  function hasTrackingNewValue(change) {
    return !!change && typeof change === "object" && Object.prototype.hasOwnProperty.call(change, "new");
  }

  function formatTrackingValue(value) {
    if (typeof value === "boolean") return value ? "true" : "false";
    return value;
  }

  function getActionColor(val) {
    if (val === "NEW") return "success-color";
    if (val === "UPDATE") return "yellow-color";
    if (val === "DELETE") return "active-color";
  }

  function handleTicketClicked(index, cardNum, buttonInd) {
    const data = { ...allTrackingData.filter((x) => x.user === saleAccSelected)[index] };
    const displayedData = { ...dataToBeShown[index] };
    const displayedDataArr = [...dataToBeShown];
    if (cardNum === "all") {
      displayedDataArr[index] = { ...data };
      setSelectedCardNum("all");
      setDataToBeShown(displayedDataArr);
      return;
    }
    const filterConditions = (x) => x.cardNum === cardNum;

    let comments = data.comments.filter((x) => filterConditions(x));
    let sales = data.sales.filter((x) => filterConditions(x));
    let assignments = data.assignments.filter((x) => filterConditions(x));
    let membershipsChanges = data.loginSessions.membershipsChanges.filter((x) => filterConditions(x));
    displayedDataArr[index] = {
      ...displayedData,
      comments,
      sales,
      assignments,
      loginSessions: { ...data.loginSessions, membershipsChanges }
    };

    setDataToBeShown(displayedDataArr);
    setSelectedCardNum(buttonInd + index);
  }

  async function getSalesAccActivity() {
    if (!saleAccSelected) return Swal.fire("Whoops", "please choose a sales man", "warning");
    let trackingData = await adminService.getSalesAccActivity(startDate, endDate, saleAccSelected);
    if (!trackingData[0]) return Swal.fire("Whoops", "there's no data found for this search", "warning");
    else {
      const selectedUser = trackingData.filter((x) => x.user === saleAccSelected);

      setAllTrackingData(trackingData);
      setDataToBeShown(selectedUser);
    }
  }

  function setDataBySalesman(salesman) {
    let selectedUser;
    if (allTrackingData) {
      selectedUser = allTrackingData.filter((x) => x.user === salesman);
      setDataToBeShown(selectedUser);
    }
    setSaleAccSelected(salesman);
  }
}
